export const hasResetRequest = (state) => {
	return state.hasResetRequest;
};

export const codeError = (state) => {
	return state.codeError;
};

export const requestSent = (state) => {
	return state.requestSent;
};

export const resetSent = (state) => {
	return state.resetSent;
};

export const loginStatus = (state) => {
	return state.loginStatus;
};

export const userAccountList = (state) => {
	return state.userAccountList;
};

export const hasCodeEmailed = (state) => {
	return state.hasCodeEmailed;
};

export const loginId = (state) => {
	return state.loginId;
};

export const sendingLoginAuth = (state) => {
	return state.sendingLoginAuth;
};

export const resetComplete = (state) => {
	return state.resetComplete;
};

export const resetError = (state) => {
	return state.resetError;
};

export const hasAccountSelect = (state) => {
	return state.hasAccountSelect;
};

export const loginIdFinal = (state) => {
	return state.loginIdFinal;
};

export const globalApp = (state) => {
	return state.globalApp;
};

export const tokenList = (state) => {
  return state.tokenList;
};

export const appUrl = (state) => {
  return state.appUrl;
};
